import React from 'react';
import { useDispatch } from 'react-redux';
import * as FrontendUtils from 'utils';
import styled from 'styled-components';

import { AuthClientActions } from 'ducks/auth-client';
import flag from 'node-env-flag';
import { localStorageCleanupOnSignOut } from 'utils/local-storage-management';

const { signOut } = AuthClientActions;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 150px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 10000;
  cursor: pointer;
  position: absolute;
  right: 0;
  border: 1px solid ${({ theme }) => theme.colors.selectableLightBg};
`;

const MenuItem = styled.button`
  color: ${({ theme }) => theme.colors.selectableLightBg};
  height: 30px;
  outline: 0;
  border: 0;
  cursor: pointer;
  font-size: 14px;
  background-color: ${({ theme }) => theme.colors.white};

  &:focus {
    outline: 0;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.selected};
  }
`;

interface AccountDropdownProps {
  isAdmin?: boolean;
  closeMenu?: () => void;
}

const AccountDropdown = ({ isAdmin = false, closeMenu = () => {} }: AccountDropdownProps) => {
  const dispatch = useDispatch();

  const onSignOut = (): void => {
    closeMenu();
    dispatch(signOut());
    FrontendUtils.navigate('/');
    localStorageCleanupOnSignOut();
  };

  const onUserAccount = (): void => {
    closeMenu();
    FrontendUtils.navigate('/');
  };

  const onAdminTools = (): void => {
    closeMenu();
    FrontendUtils.navigate('/admin');
  };

  const onSettings = (): void => {
    closeMenu();
    FrontendUtils.navigate('/settings');
  };

  return (
    <Container>
      <MenuItem name="Sign Out" onClick={onSignOut}>
        Sign Out
      </MenuItem>
      <MenuItem name="My Account" onClick={onUserAccount}>
        My Account
      </MenuItem>
      {isAdmin && (
        <MenuItem name="Admin Tools" onClick={onAdminTools}>
          Admin Tools
        </MenuItem>
      )}
      {/* ENABLE__GDPR_FUTURE is a feature flag to hide GDPR related UI until we are ready
      to ship it to production. @TODO remove this when full GDPR support lands. */}
      {flag(process.env.ENABLE__GDPR_FUTURE, false) && (
        <button type="button" name="Settings" className="fj-avatar-menu-item" onClick={onSettings}>
          Settings
        </button>
      )}
    </Container>
  );
};

export default AccountDropdown;
